<template>
    <Footer>
        <span class="d-block c-gray">Copyright © 京ICP备16010024号-1</span>
        <div class="d-flex-item align-right">
            <span class="c-warning">{{ lang === 'zh-cn' ? '为获得更好体验：请在IE10及更高版本浏览器查看，推荐：Chrome, Firefox, Edge, Safari等主流浏览器' : 'For a better experience: please view it in IE10 and higher browsers, recommended: Chrome, Firefox, Edge, Safari and other mainstream browsers.' }}</span>
        </div>
    </Footer>
</template>

<script type="text/javascript">
    export default {
        props: {
            lang: {
                type: String,
            }
        },
        created() {
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue